import type { ReactNode } from 'react';

export const symbol_build: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M354-370q-97.08 0-165.04-67.67Q121-505.33 121-602q0-20 3-37.5t11-36.5q3-8 9-12t12.81-6q6.81-2 14 0t13.19 8l113 113 92-86-118-118q-6.15-5.93-8.08-12.96Q261-797 263-804q2-7 6-12.25t12-8.75q19-8 36-11.5t36.85-3.5q99.23 0 168.69 69.42Q592-701.17 592-602q0 24-5 47t-13 46l221 221q27 26 26.5 63.5T793-161q-26 24-61.5 23.5T670-164L447-388q-23 8-46 13t-47 5Zm0-60q25 0 53-8t49-24l257 257q8 8 20 8t20-8q8-8 8-20t-8-20L500-498q16-21 24-49.5t8-54.5q0-75-55.5-127T350-782l102 104q9 9 8.5 21.5T451-635L318-510q-9.27 8-21.64 8-12.36 0-20.36-8l-98-97q3 77 54.67 127T354-430Zm117-58Z"
		/>
	</svg>
);
